module.exports = __webpack_public_path__ + "static/media/online-audio.b07b25bb.svg";